<template
  xmlns:height="http://www.w3.org/1999/xhtml"
  xmlns:width="http://www.w3.org/1999/xhtml"
  xmlns:float="http://www.w3.org/1999/xhtml"
  xmlns:object-fit="http://www.w3.org/1999/xhtml"
>

<div class="feedbackContainer">
  <div class="feedbackImageContainer">
    <img
          :src="`${image}`"
           class="feedbackImage"
        >
  </div>
  <div class="brand-Feedback">
    {{ brand }}
    <img class="likeImage" src="@/assets/likeButton.png"/>
  </div>
  <div class="designation-Feedback">
    {{ designation }} 
  </div>
  <div class="values-Feedback">
    <div class="valueheader">
      Beschreibung
      <img class="arrowImage" src="@/assets/arrowTop.png"/>
    </div>
    <div class="sepretorValues"></div>
    <div class="valueheader">
      <div class="desciption-Feedback two-line-ellipsis">
        {{ description }}
        </div>
      <br>
      Produktgröße 
      <img class="arrowImage" src="@/assets/arrowbottem.png"/>
    </div>
    <div class="sepretorValues"></div>
    <div class="valueheader">
      Nährwerte
      <img class="arrowImage" src="@/assets/arrowbottem.png"/>
    </div>
    <div class="sepretorValues"></div>
    <div class="valueheader">
      Zutaten und Allergene
      <img class="arrowImage" src="@/assets/arrowbottem.png"/>
    </div>
  </div>
  
</div>

</template>

<script>
  export default{
    props:[
      'brand',
      'description',
      'designation',
      'image'
    ]
  } 
</script>

<style >
    .feedbackContainer {
      width: 300px;
      height: 480px;
      background-color: #ffffff;
      border-radius: 30px;
    }
    .feedbackImageContainer{
      width: 100%;
      height: 185px;
    }
    .feedbackImage {
      padding-top: 20px;
      width: 180px;
      height: 180px;
      object-fit: scale-down;
      display: table;
      margin: 0 auto;
    }
    .brand-Feedback{
      padding-left: 25px;
      padding-right: 25px;
      font-family: 'Exo', sans-serif;
      font-weight: bold;
      height: 25px;
      font-size: 16px;
      color: #353736;
      padding-top: 5px;
    }
    .designation-Feedback{
      padding-left: 25px;
      font-family: 'Exo', sans-serif;
      font-size: 13px;
      color: #353736;
      position: relative;
     
    }
    .two-line-ellipsis {
        
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 18px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        
    }
    .values-Feedback{
      margin-top: 15px;
      height: 235px;
      border-radius: 30px;
      background-color: #F5F5F5;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .valueheader{
    font-weight: bold;
    font-size: 14px;
    color: #353736;
    font-family: 'Exo', sans-serif;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 25px;
    padding-right: 25px;
    }
    .sepretorValues{
    height: 2px;
    background-color: white;
    width: 100%;
    }
    .desciption-Feedback{
      font-size: 10px;
      color: #808080;
      font-family: 'Exo', sans-serif;
      padding-bottom: 10px;
      height: 40px;
    }
    .likeImage {
      height: 18px;
      width: 20px;
      float: right;
    }
    .arrowImage {
      margin-top: 5px;
      height: 10px;
      width: 18px;
      float: right;
    }
    
    
    
</style>